<div class="parent-p-card">
  <div class="alert-container">
    @if (!dataLoaded) {
      <span class="fa fa-spinner list-spinner"></span>
    }
    <div class="p-grid p-fluid">
      <div class="col-md-12 col-sm-12 col-xs-12">
        <h2>Alerts</h2>
        <!--        <div class="close-alerts"><i class="pi pi-times-circle" (click)="toggleAlertMenu()"></i></div>-->
      </div>
    </div>
    @if (alertsList && alertsList?.length >= 8) {
      <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 p-mb-4 text-align-middle">
        <p-button (click)="closeAlerts()" class="clear-all-button p-mr-2" icon="fas fa-bell gly-rotate-22-5"
                  label="View All" pTooltip="View All" tooltipPosition="bottom"></p-button>
        @if (alertsList && alertsList.length > 0) {
          <p-button (click)="clearAll()" class="clear-all-button" icon="pi pi-times"
                    label="Clear All" pTooltip="Clear All" tooltipPosition="bottom"></p-button>
        }
      </div>
    }
    @for (alert of alertsList; track alert; let i = $index) {
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="list-card">
          <div class="p-grid p-fluid">
            @if(alert.TargetDBEntityEnumerator === 'COMMRESPONSE'){
              <div class="col-md-12 col-sm-12 col-xs-8 p-ml-2">
                <h3>{{ alert.Title }}</h3>
                <div [innerHTML]="alert.Body | slice:0:25" class="list-subheader comm-alert"></div>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 p-mt-2 p-ml-2 p-mb-2 text-align-right">
                @if (alert.GoURL) {
                  <p-button (click)="openMessage(alert.GoURL, alert.Body)" class="p-mr-2"
                            icon="fas fa-comments" pTooltip="Open Message" tooltipPosition="bottom"></p-button>
                }
                <p-button (click)="clearAlert(alert.SharableId)" class="p-mr-3" icon="fas fa-times"
                          pTooltip="Clear Alert" tooltipPosition="bottom"></p-button>
              </div>
            } @else {
              <div class="col-md-12 col-sm-12 col-xs-8 p-ml-2">
                <h3>{{ alert.Title }}</h3>
                <div [innerHTML]="alert.Body" class="list-subheader"></div>
              </div>
              <div class="col-md-12 col-sm-12 col-xs-12 p-mt-2 p-ml-2 p-mb-2 text-align-right">
                @if (alert.GoURL) {
                  <p-button (click)="jumpTo(alert.SharableId, alert.GoURL)" class="p-mr-2"
                            icon="fas fa-bullseye-arrow" pTooltip="Go to Target" tooltipPosition="bottom"></p-button>
                }
                <p-button (click)="clearAlert(alert.SharableId)" class="p-mr-3" icon="fas fa-times"
                          pTooltip="Clear Alert" tooltipPosition="bottom"></p-button>
              </div>
            }
          </div>
        </div>
      </div>
    }
    @if (!alertsList || alertsList.length <= 0) {
      <div class="col-md-12 col-sm-12 col-xs-12">
        <p class="p-ml-2 p-mr-2">Thanks for checking, but there are no active alerts available at this time.</p>
      </div>
    }
    <div class="col-md-12 col-sm-12 col-xs-12 margin-top-10 p-mb-4 text-align-middle">
      <p-button (click)="closeAlerts()" class="clear-all-button p-mr-2" icon="fas fa-bell gly-rotate-22-5"
                label="View All" pTooltip="View All" tooltipPosition="bottom"></p-button>
      @if (alertsList && alertsList.length > 0) {
        <p-button (click)="clearAll()" class="clear-all-button" icon="pi pi-times"
                  label="Clear All" pTooltip="Clear All" tooltipPosition="bottom"></p-button>
      }
    </div>
  </div>
</div>
